<template>
  <div class="errors-v2">
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>User Profile</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-tabs dark vertical>
      <v-tabs-slider color="teal lighten-3"></v-tabs-slider>

      <v-tab
        v-for="(errors, topic) in groupedBySummary"
        :key="topic"
        :href="'#tab-' + topic"
        grow
        class="tab-label"
      >
        <div class="d-flex justify-space-between">
          <div>{{ topic }}</div>
          <v-chip x-small color="red" class="ml-4">
            {{ errors.length }}
          </v-chip>
        </div>
      </v-tab>
      <v-tab-item
        vertical
        v-for="(errors, topic) in groupedBySummary"
        :key="topic"
        :value="'tab-' + topic"
      >
        <v-card flat>
          <v-card-text>
            <ErrorsDataIterator :items="errors" @open-error="openError" />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="dialog" width="700">
      <ErrorContent
        :error="currentError"
        @retry="retryOne"
        @delete-error="deleteOne"
        @open-content="openContent"
      />
    </v-dialog>
    <v-dialog v-model="contentDialog">
      <v-card>
        <v-card-title>Details</v-card-title>
        <v-card-text>
          <vue-json-pretty
            :path="'res'"
            :data="currentContent"
          ></vue-json-pretty>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { groupBy } from "lodash";
import VueJsonPretty from "vue-json-pretty";

import ErrorsDataIterator from "@/components/Errors/ErrorsDataIterator";
import ErrorContent from "@/components/Errors/ErrorContent";

export default {
  components: {
    ErrorsDataIterator,
    ErrorContent,
    VueJsonPretty,
  },
  data() {
    return {
      errorsSummary: [],
      currentError: {},
      dialog: false,
      contentDialog: false,
    };
  },
  computed: {
    groupedBySummary() {
      return groupBy(this.errorsSummary, "topic");
    },
  },
  methods: {
    ...mapActions({
      setError: "setError",
    }),
    ...mapActions("orders", {
      fetchErrorsSummary: "fetchErrorsSummary",
      fetchErrorContent: "fetchErrorContent",
      retryError: "retryError",
      deleteError: "deleteError",
    }),
    async openError(path) {
      path = "data/errors/" + path;
      this.currentError = await this.fetchErrorContent({ path });
      this.currentError.path = path;
      this.dialog = true;
    },
    async openContent(path) {
      try {
        let data = await this.fetchErrorContent({ path: path });
        this.currentContent = data;
        this.contentDialog = true;
      } catch (error) {
        this.setError(error);
      }
    },
    async retryOne(path, topic_name, error_path) {
      await this.retryError({ path, topic_name, error_path });
      await this.refresh();
      this.dialog = false;
      this.contentDialog = false;
      this.currentError = {};
    },
    async deleteOne(path) {
      await this.deleteError({ path: path });
      await this.refresh();
      this.dialog = false;
      this.contentDialog = false;
      this.currentError = {};
    },
    async refresh() {
      this.errorsSummary = await this.fetchErrorsSummary();
    },
  },
  async mounted() {
    this.refresh();
  },
};
</script>

<style scoped lang="scss">
.tab-label {
  text-transform: lowercase !important;
  justify-content: start !important;
  letter-spacing: 0.3px;
  font-size: 0.8rem;
  width: 100%;
}
</style>
